// ---------------------------
// Product Gallery Carousel - Simplified and Robust
// ---------------------------
document.addEventListener('DOMContentLoaded', function() {
  const galleryContainer = document.querySelector('.gallery-container');
  const mainImage = document.querySelector('.gallery-image-container img');
  const prevButton = document.querySelector('.gallery-nav--prev');
  const nextButton = document.querySelector('.gallery-nav--next');
  const indicators = document.querySelectorAll('.gallery-indicator');

  if (!galleryContainer || !mainImage) return;

  const productImagesData = galleryContainer.getAttribute('data-product-images');
  let productImages = [];
  try {
    productImages = JSON.parse(productImagesData || '[]').map(url =>
      url && url.startsWith('//') ? 'https:' + url : url
    );
  } catch (e) {
    console.error('Failed to parse product images:', e);
    return;
  }

  if (productImages.length <= 1) {
    if (prevButton) prevButton.style.display = 'none';
    if (nextButton) nextButton.style.display = 'none';
    const indicatorsContainer = document.querySelector('.gallery-indicators');
    if (indicatorsContainer) indicatorsContainer.style.display = 'none';
    return;
  }

  let currentIndex = 0;
  let isTransitioning = false;

  function updateImage(index) {
    if (index < 0 || index >= productImages.length || isTransitioning) return;
    isTransitioning = true;
    currentIndex = index;

    const url = productImages[index];
    mainImage.src = url;
    mainImage.srcset = url + ' 1x';
    mainImage.removeAttribute('sizes');

    indicators.forEach((indicator, i) => {
      if (indicator) indicator.classList.toggle('active', i === index);
    });

    if (prevButton) prevButton.disabled = index === 0;
    if (nextButton) nextButton.disabled = index === productImages.length - 1;

    isTransitioning = false;
  }

  if (prevButton) {
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (currentIndex > 0) updateImage(currentIndex - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (currentIndex < productImages.length - 1) updateImage(currentIndex + 1);
    });
  }

  indicators.forEach((indicator, index) => {
    if (indicator) {
      indicator.addEventListener('click', function(e) {
        e.preventDefault();
        updateImage(index);
      });
    }
  });

  updateImage(0);
});

// ---------------------------
// Smooth Truncate + Gradient + Read More / Show Less
// ---------------------------
document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.product-header-description');

  containers.forEach(container => {
    const content = container.querySelector('.description-content');
    const wrapper = container.querySelector('.description-wrapper');
    const btn = container.querySelector('.read-more-btn');
    const readMoreText = container.querySelector('.read-more-text');
    const readLessText = container.querySelector('.read-less-text');
    if (!content || !btn || !wrapper) return;

    const maxLength = parseInt(content.dataset.maxLength, 10) || 500;
    const fullHTML = content.innerHTML.trim();

    // Strip tags to check visible text length
    const temp = document.createElement('div');
    temp.innerHTML = fullHTML;
    const textOnly = temp.textContent || temp.innerText || '';

    // Skip truncation if description already short
    if (textOnly.length <= maxLength) {
      btn.style.display = 'none';
      wrapper.style.maxHeight = 'none';
      wrapper.classList.add('expanded');
      return;
    }

    // --- Generate truncated HTML ---
    const truncatedHTML = truncateHTML(fullHTML, maxLength);
    content.innerHTML = truncatedHTML;

    // --- Define fixed collapsed height (in px) ---
    const collapsedHeight = 200; // 👈 adjust this value if needed

    // --- Measure full (expanded) height with hidden clone ---
    const clone = content.cloneNode(true);
    clone.innerHTML = fullHTML;
    Object.assign(clone.style, {
      position: 'absolute',
      visibility: 'hidden',
      height: 'auto',
      maxHeight: 'none',
      overflow: 'visible'
    });
    content.parentNode.appendChild(clone);
    const expandedHeight = clone.scrollHeight;
    clone.remove();

    // --- Initialize collapsed state ---
    wrapper.style.maxHeight = collapsedHeight + 'px';
    let expanded = false;

    btn.addEventListener('click', () => {
      expanded = !expanded;

      if (expanded) {
        content.innerHTML = fullHTML;
        wrapper.classList.add('expanded');
        wrapper.style.maxHeight = expandedHeight + 'px';
        readMoreText.style.display = 'none';
        readLessText.style.display = 'inline';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        wrapper.style.maxHeight = collapsedHeight + 'px';
        readMoreText.style.display = 'inline';
        readLessText.style.display = 'none';
        btn.setAttribute('aria-expanded', 'false');

        // Restore truncated version after animation
        wrapper.addEventListener(
          'transitionend',
          () => {
            if (!expanded) {
              content.innerHTML = truncatedHTML;
              wrapper.classList.remove('expanded');
            }
          },
          { once: true }
        );
      }
    });

    // --- Responsive resizing ---
    window.addEventListener('resize', () => {
      if (expanded) {
        const tempClone = content.cloneNode(true);
        tempClone.innerHTML = fullHTML;
        Object.assign(tempClone.style, {
          position: 'absolute',
          visibility: 'hidden',
          height: 'auto',
          maxHeight: 'none'
        });
        content.parentNode.appendChild(tempClone);
        wrapper.style.maxHeight = tempClone.scrollHeight + 'px';
        tempClone.remove();
      } else {
        wrapper.style.maxHeight = collapsedHeight + 'px';
      }
    });
  });

  // --- Safe HTML truncation helper ---
  function truncateHTML(html, maxChars) {
    const div = document.createElement('div');
    div.innerHTML = html;
    let charCount = 0;
    const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null, false);
    let done = false;

    while (walker.nextNode() && !done) {
      const node = walker.currentNode;
      const remaining = maxChars - charCount;

      if (node.textContent.length > remaining) {
        node.textContent = node.textContent.slice(0, remaining).trim() + '…';
        done = true;
      } else {
        charCount += node.textContent.length;
      }
    }

    if (done) {
      let current;
      while ((current = walker.nextNode())) {
        if (current.parentNode) current.parentNode.removeChild(current);
      }
    }

    return div.innerHTML;
  }
});



// ---------------------------
// Color Swatch + ATC + Price + Label + Model Integration (PDP)
// ---------------------------
document.addEventListener('DOMContentLoaded', function() {
  const colorSwatches = document.querySelectorAll('.color-swatch');
  const galleryContainer = document.querySelector('.gallery-container');
  const mainImage = document.querySelector('.gallery-image-container img');
  const colorSelectedEl = document.querySelector('.color-label .color-selected');
  const priceEl = document.querySelector('.product-header-price .price');
  const modelEl = document.querySelector('#product_model'); // Model number element

  let productJson = null;

  async function loadProductJson() {
    if (productJson) return productJson;
    const handle = (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!handle) return null;

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      productJson = await res.json();
      return productJson;
    } catch (e) {
      console.warn('Could not load product JSON:', e);
      return null;
    }
  }

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function updateATCPriceModel(variantId) {
    if (!variantId) return;
    const btns = document.querySelectorAll('add-to-cart-btn');
    if (!btns.length) return;

    loadProductJson().then((prod) => {
      if (!prod) return;
      const variant = (prod.variants || []).find(v => String(v.id) === String(variantId));
      if (!variant) return;

      // --- ATC state ---
      btns.forEach((btn) => {
        btn.setAttribute('data-productid', String(variantId));
        btn.dataset.productid = String(variantId);
        if (variant.available) {
          btn.setAvailableUI();
        } else {
          btn.setSoldOutUI();
        }
      });

      // --- Price update (PDP) ---
      if (priceEl) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (onSale) {
          priceEl.innerHTML = `
            <s>${formatMoney(variant.compare_at_price)}</s>
            <span class="bc-sf-filter-product-item-sale-price">${formatMoney(variant.price)}</span>
          `;
        } else {
          priceEl.innerHTML = `<span>${formatMoney(variant.price)}</span>`;
        }
      }

      // --- Safe Sale badge toggle (PDP) ---
      const badgeContainer = document.querySelector('.badge-container');
      if (badgeContainer) {
        const existingSaleBadge = badgeContainer.querySelector('.product-header-badge.badge-sale');
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

        if (onSale) {
          if (!existingSaleBadge) {
            const saleBadge = document.createElement('div');
            saleBadge.className = 'product-header-badge badge-sale';
            saleBadge.dataset.source = 'js';
            saleBadge.innerHTML = `<span>&#11834; Sale</span>`;
            badgeContainer.insertAdjacentElement('afterbegin', saleBadge);
          } else {
            existingSaleBadge.style.display = '';
          }
        } else {
          if (existingSaleBadge) {
            if (existingSaleBadge.dataset.source === 'js') {
              existingSaleBadge.remove();
            } else {
              existingSaleBadge.style.display = 'none';
            }
          }
        }
      }

      // --- Model number update ---
      if (modelEl) {
        if (variant.sku) {
          modelEl.textContent = `Model: ${variant.sku}`;
        } else {
          modelEl.textContent = '';
        }
      }
    });
  }

  function updateGalleryImage(imgUrl) {
    if (!galleryContainer || !mainImage || !imgUrl) return;
    const productImagesData = galleryContainer.getAttribute('data-product-images') || '[]';
    let productImages = [];
    try {
      productImages = JSON.parse(productImagesData);
    } catch (e) {}
    if (productImages.length > 0) {
      productImages[0] = imgUrl.startsWith('//') ? 'https:' + imgUrl : imgUrl;
      galleryContainer.setAttribute('data-product-images', JSON.stringify(productImages));
    }
    mainImage.src = imgUrl.startsWith('//') ? 'https:' + imgUrl : imgUrl;
    mainImage.srcset = imgUrl + ' 1x';
    mainImage.removeAttribute('sizes');
  }

  if (colorSwatches.length > 0) {
    colorSwatches.forEach((swatch) => {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();

        const variantId = swatch.getAttribute('data-variant-id');
        const variantImg = swatch.getAttribute('data-image');
        const variantLabel = swatch.getAttribute('title') || swatch.getAttribute('data-color');
        if (!variantId) return;

        // Active state
        colorSwatches.forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');

        // Update ATC + price + model
        updateATCPriceModel(variantId);

        // Update gallery
        if (variantImg) updateGalleryImage(variantImg);

        // Update color label
        if (colorSelectedEl && variantLabel) {
          colorSelectedEl.textContent = variantLabel;
        }
      });
    });

    // Initial sync for active swatch (Option 1 flash fix)
    const activeSwatch = document.querySelector('.color-swatch.active') || colorSwatches[0];
    if (activeSwatch) {
      const variantId = activeSwatch.getAttribute('data-variant-id');
      const variantImg = activeSwatch.getAttribute('data-image');
      const variantLabel = activeSwatch.getAttribute('title') || activeSwatch.getAttribute('data-color');
      const idInput = document.querySelector('input[name="id"]');
      const currentVariantId = idInput ? idInput.value : null;

      // ✅ Only update if variant differs from current variant
      if (variantId && variantId !== currentVariantId) {
        updateATCPriceModel(variantId);
      }

      if (variantImg) updateGalleryImage(variantImg);
      if (colorSelectedEl && variantLabel) {
        colorSelectedEl.textContent = variantLabel;
      }
    }
  }
});

// ---------------------------
// Collection Page Variant Switching + Safe Sale Badge Toggle
// ---------------------------
document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll('.product-card');

  productCards.forEach((card) => {
    const variantButtons = card.querySelectorAll('.product-card__variant-color');
    const priceEl = card.querySelector('.price');
    const imgEl = card.querySelector('img');
    const badgeContainer = card.querySelector('.badge-container');
    if (!variantButtons.length || !priceEl || !imgEl) return;

    const linkEl = card.querySelector('a[href*="/products/"]');
    const handleMatch = linkEl ? linkEl.href.match(/\/products\/([^/?#]+)/) : null;
    const handle = handleMatch ? handleMatch[1] : null;
    let productJson = null;

    async function loadProductJson() {
      if (productJson) return productJson;
      if (!handle) return null;
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        productJson = await res.json();
        return productJson;
      } catch (err) {
        console.warn('Could not load product JSON for handle:', handle, err);
        return null;
      }
    }

    function formatMoney(cents) {
      return `$${(cents / 100).toFixed(2)}`;
    }

    function updateCardPriceAndBadge(variant) {
      if (!variant || !priceEl) return;

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      let html = '';

      if (onSale) {
        html = `
          <s>${formatMoney(variant.compare_at_price)}</s>
          <span class="bc-sf-filter-product-item-sale-price">${formatMoney(variant.price)}</span>
        `;
      } else {
        html = `<span>${formatMoney(variant.price)}</span>`;
      }

      priceEl.innerHTML = html;

      // --- Safe Sale badge toggle (Collection Card) ---
      if (badgeContainer) {
        const existingSaleBadge = badgeContainer.querySelector('.product-header-badge.badge-sale');
        if (onSale) {
          if (!existingSaleBadge) {
            const saleBadge = document.createElement('div');
            saleBadge.className = 'product-header-badge badge-sale';
            saleBadge.dataset.source = 'js';
            saleBadge.innerHTML = `<span>&#11834; Sale</span>`;
            badgeContainer.insertAdjacentElement('afterbegin', saleBadge);
          } else {
            existingSaleBadge.style.display = '';
          }
        } else {
          if (existingSaleBadge) {
            if (existingSaleBadge.dataset.source === 'js') {
              existingSaleBadge.remove();
            } else {
              existingSaleBadge.style.display = 'none';
            }
          }
        }
      }
    }

    function updateCardImage(imgUrl) {
      if (!imgUrl || !imgEl) return;
      const finalUrl = imgUrl.startsWith('//') ? 'https:' + imgUrl : imgUrl;
      imgEl.src = finalUrl;
      imgEl.srcset = finalUrl + ' 1x';
    }

    variantButtons.forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();

        const variantId = btn.getAttribute('data-variantid');
        const variantImg = btn.getAttribute('data-variantimage');

        variantButtons.forEach((b) => b.classList.remove('selected'));
        btn.classList.add('selected');

        if (variantImg) updateCardImage(variantImg);

        const prod = await loadProductJson();
        if (!prod) return;
        const variant = prod.variants.find((v) => String(v.id) === String(variantId));
        if (variant) updateCardPriceAndBadge(variant);
      });
    });
  });
});
